/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestConnectionResultDto } from '../../models/test-connection-result-dto';
import { TestDataSourceRequest } from '../../models/test-data-source-request';

export interface DatasourcesTestPost$Plain$Params {
      body?: TestDataSourceRequest
}

export function datasourcesTestPost$Plain(http: HttpClient, rootUrl: string, params?: DatasourcesTestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesTestPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestConnectionResultDto>;
    })
  );
}

datasourcesTestPost$Plain.PATH = '/datasources/test';
